function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M62.5529 52.2088C58.7498 50.5593 55.8078 47.4038 54.3727 43.2443C52.8658 38.9414 53.1528 34.2799 55.162 30.4073C59.5391 22.2317 67.6475 21.156 73.7468 23.666C80.3484 26.4629 85.5148 33.7062 82.788 42.312C82.3575 43.9615 81.5682 45.4675 80.4201 46.9735C77.3346 50.9896 72.6705 53.2845 68.0063 53.2845C66.1407 53.2845 64.275 52.9259 62.5529 52.2088ZM57.0276 31.4113C55.3055 34.7102 55.0185 38.798 56.3819 42.5272C57.6735 46.113 60.1132 48.8381 63.4139 50.2007C68.6521 52.4239 74.9667 50.5593 78.698 45.6827C79.7026 44.3918 80.3483 43.1009 80.7071 41.7383C83.075 34.3516 78.5545 28.1124 72.8858 25.674C71.3071 25.0286 69.5132 24.5983 67.6475 24.5983C63.7727 24.5983 59.6826 26.3912 57.0276 31.4113Z",
  fill: "#5492F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M31.8411 4.08784C31.7694 4.08784 31.7694 4.08784 31.6976 4.08784C31.9129 3.94441 32.1282 3.80098 32.3435 3.72927C32.2717 3.80098 32.2717 3.80098 32.1999 3.8727C31.7694 4.3747 30.98 4.44642 30.406 4.23127C29.8319 4.01613 29.3296 3.3707 29.4014 2.72526C29.4014 2.15154 29.6885 1.57781 30.1908 1.29095C30.7648 0.932378 31.6976 1.00409 32.1999 1.57781C32.2717 1.64953 32.2717 1.64952 32.3435 1.72124C32.1282 1.57781 31.9129 1.43438 31.6976 1.36266C31.7694 1.36266 31.7694 1.36266 31.8411 1.36266C33.2045 1.57781 33.2045 3.80098 31.8411 4.08784Z",
  fill: "#5492F2"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M25.3838 8.17556C27.3929 8.17556 27.3929 5.0918 25.3838 5.0918C23.3747 5.0918 23.3747 8.17556 25.3838 8.17556Z",
  fill: "#5492F2"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M18.9247 11.6179C20.7186 11.6179 20.7186 8.82104 18.9247 8.82104C17.059 8.82104 17.059 11.6179 18.9247 11.6179Z",
  fill: "#5492F2"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M13.5431 16.4227C15.624 16.4227 15.624 13.1956 13.5431 13.1956C11.4622 13.2673 11.4622 16.4227 13.5431 16.4227Z",
  fill: "#5492F2"
})));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M6.79919 19.8652C6.79919 19.7934 6.79919 19.7217 6.79919 19.65C6.87095 19.8652 6.94274 20.0803 7.0145 20.2955C7.0145 20.2955 7.01452 20.2237 6.94276 20.2237C6.44046 19.2914 7.08624 18.0723 8.16259 18.0723C9.23894 18.0723 9.88481 19.2914 9.38251 20.2237C9.38251 20.2237 9.38244 20.2955 9.31068 20.2955C9.38244 20.0803 9.45423 19.8652 9.52599 19.65C9.52599 19.7217 9.52599 19.7934 9.52599 19.8652C9.45423 20.5823 8.9519 21.2278 8.23433 21.156C7.37325 21.156 6.87095 20.5823 6.79919 19.8652Z",
  fill: "#5492F2"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M3.85644 25.3155C5.79379 25.3155 5.79379 22.2317 3.85644 22.2317C1.84733 22.3034 1.84733 25.3155 3.85644 25.3155Z",
  fill: "#5492F2"
})));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0.125 5.52218L0.914302 126.291C0.914302 128.012 2.34941 129.375 4.21507 129.375L94.7715 128.801C92.3318 132.53 95.2738 125.215 95.2738 123.494L93.9104 6.02418C93.9104 5.37874 93.8387 4.73331 93.7669 4.08787C93.2646 1.0041 90.1791 3.01213 93.0494 2.94042C94.4845 2.94042 86.0172 2.07983 82.7165 2.07983L3.35403 2.3667C1.56013 2.43842 0.125 3.80101 0.125 5.52218Z",
  fill: "url(#paint0_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13016 0.860581C32.2006 0.860581 63.3428 0.502007 94.4132 0C96.4941 0 96.4941 3.15547 94.4132 3.22719C63.271 3.72919 32.2006 3.72919 1.13016 3.22719C-0.37672 3.22719 -0.37672 0.860581 1.13016 0.860581Z",
  fill: "#5492F2"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13016 127.08C32.2006 127.08 63.3428 126.721 94.4132 126.219C96.4941 126.219 96.4941 129.375 94.4132 129.446C63.271 129.948 32.2006 129.948 1.13016 129.446C-0.37672 129.446 -0.37672 127.08 1.13016 127.08Z",
  fill: "#5492F2"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M2.92504 1.86463C3.06855 44.0333 3.35554 86.202 3.78607 128.371C3.78607 130.45 0.557081 130.45 0.557081 128.371C0.126549 86.202 0.126566 44.0333 0.485343 1.86463C0.557098 0.358601 2.92504 0.358601 2.92504 1.86463Z",
  fill: "#5492F2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M16.917 18.7895C31.7705 18.7178 46.7675 18.4309 61.621 17.9289C63.7019 17.8572 63.7019 21.0844 61.621 21.1561C46.6957 21.6581 31.8423 21.5864 16.917 21.1561C15.4101 21.1561 15.3384 18.7895 16.917 18.7895Z",
  fill: "#5492F2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M16.917 41.7385C36.5782 41.7385 56.3111 41.3799 75.9723 40.8779C78.0533 40.8062 78.0533 44.0334 75.9723 44.1051C56.2394 44.6071 36.5782 44.5354 16.917 44.1051C15.4101 44.1051 15.3384 41.7385 16.917 41.7385Z",
  fill: "#5492F2"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M16.917 56.0815C36.5782 56.0815 56.3111 55.7229 75.9723 55.2209C78.0533 55.1492 78.0533 58.3764 75.9723 58.4481C56.2394 58.9501 36.5782 58.8784 16.917 58.4481C15.4101 58.4481 15.3384 56.0815 16.917 56.0815Z",
  fill: "#5492F2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M16.917 69.7075C36.5782 69.7075 56.3111 69.3489 75.9723 68.8469C78.0533 68.7752 78.0533 72.0024 75.9723 72.0741C56.2394 72.5761 36.5782 72.5044 16.917 72.0741C15.4101 72.0741 15.3384 69.7075 16.917 69.7075Z",
  fill: "#5492F2"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M16.917 84.7675C36.5782 84.7675 56.3111 84.409 75.9723 83.9069C78.0533 83.8352 78.0533 87.0624 75.9723 87.1342C56.2394 87.6362 36.5782 87.5644 16.917 87.1342C15.4101 87.1342 15.3384 84.7675 16.917 84.7675Z",
  fill: "#5492F2"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M96.2064 1.86463C96.3499 44.0333 96.637 86.202 97.0675 128.371C97.0675 130.45 93.8383 130.45 93.8383 128.371C93.4078 86.202 93.4078 44.0333 93.7666 1.86463C93.8384 0.358601 96.2064 0.358601 96.2064 1.86463Z",
  fill: "#5492F2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M125.553 84.2088C121.75 82.5593 118.808 79.4038 117.373 75.2443C115.866 70.9414 116.153 66.2799 118.162 62.4073C122.539 54.2317 130.648 53.156 136.747 55.666C143.348 58.4629 148.515 65.7062 145.788 74.312C145.358 75.9615 144.568 77.4675 143.42 78.9735C140.335 82.9896 135.67 85.2845 131.006 85.2845C129.141 85.2845 127.275 84.9259 125.553 84.2088ZM120.028 63.4113C118.305 66.7102 118.019 70.798 119.382 74.5272C120.674 78.113 123.113 80.8381 126.414 82.2007C131.652 84.4239 137.967 82.5593 141.698 77.6827C142.703 76.3918 143.348 75.1009 143.707 73.7383C146.075 66.3516 141.554 60.1124 135.886 57.674C134.307 57.0286 132.513 56.5983 130.648 56.5983C126.773 56.5983 122.683 58.3912 120.028 63.4113Z",
  fill: "#5492F2"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M94.8411 36.0878C94.7694 36.0878 94.7694 36.0878 94.6976 36.0878C94.9129 35.9444 95.1282 35.801 95.3435 35.7293C95.2717 35.801 95.2717 35.801 95.1999 35.8727C94.7694 36.3747 93.98 36.4464 93.406 36.2313C92.8319 36.0161 92.3296 35.3707 92.4014 34.7253C92.4014 34.1515 92.6885 33.5778 93.1908 33.291C93.7648 32.9324 94.6976 33.0041 95.1999 33.5778C95.2717 33.6495 95.2717 33.6495 95.3435 33.7212C95.1282 33.5778 94.9129 33.4344 94.6976 33.3627C94.7694 33.3627 94.7694 33.3627 94.8411 33.3627C96.2045 33.5778 96.2045 35.801 94.8411 36.0878Z",
  fill: "#5492F2"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M88.3838 40.1756C90.3929 40.1756 90.3929 37.0918 88.3838 37.0918C86.3747 37.0918 86.3747 40.1756 88.3838 40.1756Z",
  fill: "#5492F2"
})));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M81.9247 43.6179C83.7186 43.6179 83.7186 40.821 81.9247 40.821C80.059 40.821 80.059 43.6179 81.9247 43.6179Z",
  fill: "#5492F2"
})));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M76.5431 48.4227C78.624 48.4227 78.624 45.1956 76.5431 45.1956C74.4622 45.2673 74.4622 48.4227 76.5431 48.4227Z",
  fill: "#5492F2"
})));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M69.7992 51.8652C69.7992 51.7934 69.7992 51.7217 69.7992 51.65C69.871 51.8652 69.9427 52.0803 70.0145 52.2955C70.0145 52.2955 70.0145 52.2237 69.9428 52.2237C69.4405 51.2914 70.0862 50.0723 71.1626 50.0723C72.2389 50.0723 72.8848 51.2914 72.3825 52.2237C72.3825 52.2237 72.3824 52.2955 72.3107 52.2955C72.3824 52.0803 72.4542 51.8652 72.526 51.65C72.526 51.7217 72.526 51.7934 72.526 51.8652C72.4542 52.5823 71.9519 53.2278 71.2343 53.156C70.3732 53.156 69.871 52.5823 69.7992 51.8652Z",
  fill: "#5492F2"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M66.8564 57.3155C68.7938 57.3155 68.7938 54.2317 66.8564 54.2317C64.8473 54.3034 64.8473 57.3155 66.8564 57.3155Z",
  fill: "#5492F2"
})));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M63.125 37.5222L63.9143 158.291C63.9143 160.012 65.3494 161.375 67.2151 161.375L157.772 160.801C155.332 164.53 158.274 157.215 158.274 155.494L156.91 38.0242C156.91 37.3787 156.839 36.7333 156.767 36.0879C156.265 33.0041 153.179 35.0121 156.049 34.9404C157.484 34.9404 149.017 34.0798 145.716 34.0798L66.354 34.3667C64.5601 34.4384 63.125 35.801 63.125 37.5222Z",
  fill: "url(#paint1_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M64.1302 32.8606C95.2006 32.8606 126.343 32.502 157.413 32C159.494 32 159.494 35.1555 157.413 35.2272C126.271 35.7292 95.2006 35.7292 64.1302 35.2272C62.6233 35.2272 62.6233 32.8606 64.1302 32.8606Z",
  fill: "#5492F2"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M64.1302 159.08C95.2006 159.08 126.343 158.721 157.413 158.219C159.494 158.219 159.494 161.375 157.413 161.446C126.271 161.948 95.2006 161.948 64.1302 161.446C62.6233 161.446 62.6233 159.08 64.1302 159.08Z",
  fill: "#5492F2"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M65.925 33.8646C66.0686 76.0333 66.3555 118.202 66.7861 160.371C66.7861 162.45 63.5571 162.45 63.5571 160.371C63.1265 118.202 63.1266 76.0333 63.4853 33.8646C63.5571 32.3586 65.925 32.3586 65.925 33.8646Z",
  fill: "#5492F2"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M79.917 50.7895C94.7705 50.7178 109.767 50.4309 124.621 49.9289C126.702 49.8572 126.702 53.0844 124.621 53.1561C109.696 53.6581 94.8423 53.5864 79.917 53.1561C78.4101 53.1561 78.3384 50.7895 79.917 50.7895Z",
  fill: "#5492F2"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M79.917 73.7385C99.5782 73.7385 119.311 73.3799 138.972 72.8779C141.053 72.8062 141.053 76.0334 138.972 76.1051C119.239 76.6071 99.5782 76.5354 79.917 76.1051C78.4101 76.1051 78.3384 73.7385 79.917 73.7385Z",
  fill: "#5492F2"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M79.917 88.0815C99.5782 88.0815 119.311 87.7229 138.972 87.2209C141.053 87.1492 141.053 90.3764 138.972 90.4481C119.239 90.9501 99.5782 90.8784 79.917 90.4481C78.4101 90.4481 78.3384 88.0815 79.917 88.0815Z",
  fill: "#5492F2"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M79.917 101.707C99.5782 101.707 119.311 101.349 138.972 100.847C141.053 100.775 141.053 104.002 138.972 104.074C119.239 104.576 99.5782 104.504 79.917 104.074C78.4101 104.074 78.3384 101.707 79.917 101.707Z",
  fill: "#5492F2"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M79.917 116.768C99.5782 116.768 119.311 116.409 138.972 115.907C141.053 115.835 141.053 119.062 138.972 119.134C119.239 119.636 99.5782 119.564 79.917 119.134C78.4101 119.134 78.3384 116.768 79.917 116.768Z",
  fill: "#5492F2"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M159.206 33.8646C159.35 76.0333 159.637 118.202 160.068 160.371C160.068 162.45 156.838 162.45 156.838 160.371C156.408 118.202 156.408 76.0333 156.767 33.8646C156.838 32.3586 159.206 32.3586 159.206 33.8646Z",
  fill: "#5492F2"
});

var _ref36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 47.6994,
  y1: 2.07983,
  x2: 47.6994,
  y2: 129.846,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34375,
  stopColor: "#BFCDE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.708333,
  stopColor: "white",
  stopOpacity: 0.229167
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 110.699,
  y1: 34.0798,
  x2: 110.699,
  y2: 161.846,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34375,
  stopColor: "#BFCDE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.708333,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.99
})));

function SvgBills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.76ef11da.svg";
export { ForwardRef as ReactComponent };